import { Box, Container, Grid, Image } from '@components/gassan-ui'
import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import { useLocalization } from '@components/Localization'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { Heading } from '@rolex-ui'
import { rem } from 'polished'
import React, { FC } from 'react'
import styled from 'styled-components'
import { gridColumn, GridColumnProps } from 'styled-system'

const Title = styled(Box)`
  background: white;
  padding-top: 0.75rem;
  transition: transform 0.2s ease 0s;
  position: relative;
  z-index: 2;
`

const Link = styled(CleanLink)<GridColumnProps>`
  ${gridColumn};
  text-align: left;

  img {
    transition: transform 0.4s ease 0s;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      ${Title} {
        transform: translateY(-1.25rem);
      }
    }
  }
`

type FeaturedItem = {
  images: AssetsElement[]
  title: string
  href: string
}

type Props = {
  items: FeaturedItem[]
  title?: string
}

const FeaturedSelection: FC<Props> = ({ items, title }) => {
  const { lang } = useLocalization()
  return (
    <Container maxWidth={rem(1040)} mb="10vh">
      {title && (
        <Heading variant="verySmallTitle" as="h2" mb="1.25rem">
          {title}
        </Heading>
      )}
      <Grid
        gridTemplateColumns="minmax(0, 1fr)  minmax(0, 1fr) "
        gridColumnGap="1.25rem"
        gridRowGap={['1.25rem', '2rem']}
      >
        {items.map((item, key) => (
          <Link
            gridColumn={key === 2 && '1 / span 2'}
            href={`/${lang}/rolex/${item.href}`}
            key={`${item.href}-${key}`}
          >
            <Image
              ratio={key !== 2 ? [1.53, 0.73] : [0.73, 0.35]}
              sources={[
                getKontentImage(item.images[0]?.value[0]?.url, {
                  width: 350
                }),
                getKontentImage(item.images[1]?.value[0]?.url, {
                  width: 600
                })
              ]}
              placeholderSrc={getKontentImage(item.images[1]?.value[0]?.url, {
                width: 50,
                height: 50
              })}
            />
            <Title bg="white">
              <Heading variant="gridTitle" as="h3">
                {item.title}
              </Heading>
            </Title>
          </Link>
        ))}
      </Grid>
    </Container>
  )
}

export default FeaturedSelection
